import { SVGProps } from 'react';

const SolidFillSvg = ({ fill = 'currentColor', stroke = 'none', children, ...props }: SVGProps<SVGSVGElement>) => {
  return <svg {...{ stroke, fill, ...props }}>{children}</svg>;
};

export default SolidFillSvg;
